import { FUNC_DEFAULT, OBJECT_DEFAULT } from 'constants';
import { PAYTO_LOG_TAG } from 'features/to/const';
import usePayto from 'features/to/hooks/payment/usePayto';
import usePaytoAPI from 'features/to/hooks/payment/usePaytoAPI';
import usePaytoStore from 'features/to/hooks/payment/usePaytoStore';
import useCommonStore from 'hooks/useCommonStore';
import usePortalModal from 'hooks/usePortalModal';
import { isEmpty, isFunction } from 'lodash';
import React from 'react';
import withAddPaytoAccountsAgreement from './withAddPaytoAccountsAgreement';
import withPaytoErrorCodeModal from './withPaytoErrorCodeModal';

const withDeletePaytoAccountAgreements = (Component) => {
  const DeletePaytoAccountAgreementsComponent = withAddPaytoAccountsAgreement(
    withPaytoErrorCodeModal((props) => {
      const {
        onSelect,
        fetchPaytoAccountsAgreementLatest,
        onOpenPaytoErrorCodeModal,
      } = props || {};

      const { deletePaytoAccountAgreementById } = usePaytoAPI();
      const { setLoading } = useCommonStore();
      const { onShowDeletePaytoAccountAgreementModal } = usePayto();
      const { closePortalModalName } = usePortalModal();
      const {
        resetPaytoAccountInformation,
        resetPaytoMaxAmountEdited,
        resetPaytoAccountAuthorising,
        resetPaytoAgreementEditing,
        setPaytoAccountsAgreement,
      } = usePaytoStore();

      const onDeletePaytoAccountAgreement = (
        accountAgreement,
        callback = FUNC_DEFAULT,
        modalCallback = FUNC_DEFAULT,
        errorCallback = FUNC_DEFAULT
      ) => {
        try {
          if (isEmpty(accountAgreement)) {
            console.error(
              `🔥 ${PAYTO_LOG_TAG} ❌ onDeletePaytoAccountAgreement ➡️ accountAgreement is empty ↩`
            );
            return;
          }

          setLoading(true);
          deletePaytoAccountAgreementById(
            accountAgreement,
            (accountAgreementDeleted) => {
              resetPaytoAccountInformation();
              resetPaytoMaxAmountEdited();
              resetPaytoAccountAuthorising();
              resetPaytoAgreementEditing();
              setPaytoAccountsAgreement();
              setLoading(false);
              modalCallback();
              callback();
              console.log(
                `⭐ withDeletePaytoAccountAgreements 👉 onDeletePaytoAccountAgreement ↩`
              );
              fetchPaytoAccountsAgreementLatest(() => {
                onSelect(OBJECT_DEFAULT, OBJECT_DEFAULT, true);
              });
            },
            (errorData) => {
              if (isFunction(errorCallback)) {
                errorCallback?.();
              }
              onOpenPaytoErrorCodeModal(errorData, '', '', () => {
                if (isFunction(errorCallback)) {
                  errorCallback?.();
                }
                closePortalModalName();
              });
            }
          );
        } catch (error) {
          console.error(
            `🔥 ${PAYTO_LOG_TAG} ❌ onDeletePaytoAccountAgreement ➡️ ERROR ↩`,
            error?.message
          );
          setLoading(false);
          if (error?.response?.data?.errorCode) {
            onOpenPaytoErrorCodeModal(error?.response?.data, '', '', () => {
              if (isFunction(errorCallback)) {
                errorCallback?.();
              }
              closePortalModalName();
            });
          } else {
            if (isFunction(errorCallback)) {
              errorCallback?.();
            }
          }
        }
      };

      const onOpenDeletePaytoAccountModal = (
        accountAgreement,
        callback = FUNC_DEFAULT,
        closeCallback = FUNC_DEFAULT
      ) => {
        onShowDeletePaytoAccountAgreementModal({
          action: (modalCallback = FUNC_DEFAULT) => {
            onDeletePaytoAccountAgreement(
              accountAgreement,
              callback,
              modalCallback,
              closeCallback
            );
          },
          actionClose: closeCallback,
        });
      };

      const newProps = {
        ...props,
        onDelete: onOpenDeletePaytoAccountModal,
      };
      return <Component {...newProps} />;
    })
  );
  return DeletePaytoAccountAgreementsComponent;
};

export default withDeletePaytoAccountAgreements;
